module.exports = __webpack_public_path__ + "img/promotion-banner-mobile.3dcd43c.jpg";